const movieDataMap_eng: {
  [key: string]: {
    name: string,
    desc: string,
    director: string,
    actors: string[],
    imgs: string[],
    videos: string[],
    videoImg: string,
    screens: []
  }
} = {
  "鈴芽之旅": {
    "name": "Suzume no Tojimari",
    "desc": "Suzume (Japanese: すずめの戸締まり, Hepburn: Suzume no Tojimari, lit. 'Suzume's Locking Up') is a 2022 Japanese animated coming-of-age fantasy adventure film written and directed by Makoto Shinkai. The film follows 17-year-old high school girl Suzume Iwato and young stranger Souta Munakata, who team up to prevent a series of disasters across Japan by sealing doors from the colossal, supernatural worm that causes earthquakes after being released. ",
    "director": "Makoto Shinkai",
    "actors": ["Nanoka Hara、Hokuto Matsumura、Eri Fukatsu、Shota Sometani、Sairi Ito、Kotone Hanase"],
    "imgs": ['https://i.imgur.com/0O4Umgp.jpg'],
    "videos": [],
    "videoImg": "",
    "screens": []

  },
  "心之谷": {
    "name": "Whisper of the Heart",
    "desc": "Whisper of the Heart is a 2022 Japanese romantic drama film written and directed by Yūichirō Hirakawa based on the 1989 manga of the same name by Aoi Hiiragi. Co-distributed by Sony Pictures Entertainment and Shochiku, it takes place ten years after the original manga (as well as the 1995 anime film with the same name), and focuses on adult Shizuku and Seiji. The film stars Nana Seino and Tori Matsuzaka. Whisper of the Heart was released in Japan on October 14, 2022",
    "director": "Yuichiro Hirakawa",
    "actors": ['Nana Seino,Tori Matsuzaka,Rio Uchida,Yuki Yamada'],
    "imgs": ['https://i.imgur.com/3P9t3T8.jpg'],
    "videos": [],
    "videoImg": "",
    "screens": []
  },
  "小美人魚": {
    "name": "The Little Mermaid",
    "desc": "The Little Mermaid is a 2023 American musical romantic fantasy film directed by Rob Marshall from a screenplay by David Magee. Co-produced by Walt Disney Pictures, DeLuca Marshall, and Marc Platt Productions, it is a live-action adaptation of Disney's 1989 animated film The Little Mermaid, which itself is loosely based on Hans Christian Andersen's 1837 fairy tale. The film stars Halle Bailey as the title character, with Jonah Hauer-King, Daveed Diggs, Awkwafina, Jacob Tremblay, Noma Dumezweni, Art Malik, Javier Bardem, and Melissa McCarthy in supporting roles. The plot follows the mermaid princess Ariel, who is fascinated with the human world; after saving Prince Eric from a shipwreck, she makes a deal with the sea witch Ursula to walk on land",
    "director": "Rob Marshall",
    "actors": ['Halle Bailey,Jonah Hauer-King,Daveed Diggs,Awkwafina,Jacob Tremblay,Noma Dumezweni'],
    "imgs": ['https://i.imgur.com/HhRhOIU.jpg'],
    "videos": [],
    "videoImg": "",
    "screens": []
  },
  "超級瑪利歐": {
    "name": "The Super Mario Bros. Movie",
    "desc": "The Super Mario Bros. Movie is a 2023 American animated adventure comedy film based on Nintendo's Mario video game franchise. Produced by Universal Pictures, Illumination, and Nintendo, and distributed by Universal, it was directed by Aaron Horvath and Michael Jelenic (in the latter's feature directorial debut) and written by Matthew Fogel. The ensemble voice cast includes Chris Pratt, Anya Taylor-Joy, Charlie Day, Jack Black, Keegan-Michael Key, Seth Rogen, and Fred Armisen. The film features an origin story for the brothers Mario and Luigi, Italian-American plumbers who are separated after being transported to a fantasy world and become entangled in a battle between the Mushroom Kingdom, led by Princess Peach, and the Koopas, led by Bowser. ",
    "director": "Aaron Horvath,Michael Jelenic",
    "actors": ['Chris Pratt,Anya Taylor-Joy,Charlie Day,Jack Black,Keegan-Michael Key,Seth Rogen'],
    "imgs": ['https://i.imgur.com/UZ0sMGy.jpg'],
    "videos": [],
    "videoImg": "",
    "screens": []
  },
  "星際異攻隊3": {
    "name": "Guardians of the Galaxy Vol.3",
    "desc": "Guardians of the Galaxy Vol. 3 (marketed as Guardians of the Galaxy Volume 3) is a 2023 American superhero film based on the Marvel Comics superhero team Guardians of the Galaxy, produced by Marvel Studios and distributed by Walt Disney Studios Motion Pictures. It is the sequel to Guardians of the Galaxy (2014) and Guardians of the Galaxy Vol. 2 (2017), and the 32nd film in the Marvel Cinematic Universe (MCU). Written and directed by James Gunn, it features an ensemble cast including Chris Pratt, Zoe Saldaña, Dave Bautista, Karen Gillan, Pom Klementieff, Vin Diesel, Bradley Cooper, Will Poulter, Sean Gunn, Chukwudi Iwuji, Linda Cardellini, Nathan Fillion, and Sylvester Stallone. In the film, the other Guardians race to save the life of Rocket (Cooper) from his creator, the High Evolutionary (Iwuji), who is an alien scientist trying to perfect the universe. ",
    "director": "James Gunn",
    "actors": ['Chris Pratt,Zoe Saldaña,Dave Bautista,Karen Gillan,Pom Klementieff,Vin Diesel'],
    "imgs": ['https://i.imgur.com/0EAOy08.jpg'],
    "videos": [],
    "videoImg": "",
    "screens": []
  },
  "名偵探柯南黑鐵的魚影": {
    "name": "Detective Conan: Black Iron Submarine",
    "desc": "Case Closed: Black Iron Submarine, known as Detective Conan: Black Iron Submarine (Japanese: 名探偵コナン 黒鉄の魚影, Hepburn: Meitantei Konan: Kurogane no Sabumarin) in Japan, is a 2023 Japanese animated mystery film directed by Yuzuru Tachikawa. It is the twenty-sixth installment of the Case Closed film series based on the manga series of the same name by Gosho Aoyama, following the 2022 film Detective Conan: The Bride of Halloween. The film was released in Japan on April 14, 2023",
    "director": "Yuzuru Tachikawa",
    "actors": ['Minami Takayama,Wakana Yamazaki,Rikiya Koyama,Megumi Hayashibara,Yukitoshi Hori,Fumihiko Tachiki'],
    "imgs": ['https://i.imgur.com/NIjQ1Xa.jpg'],
    "videos": [],
    "videoImg": "",
    "screens": []
  },
  "絕命控制": {
    "name": "Control",
    "desc": "A mother locked inside a stark room is tasked by an unknown voice to complete increasingly complex challenges if she wants to save her daughter's life.",
    "director": "James Mark",
    "actors": ['Sara Mitich,George Tchortov,Evie Loiselle'],
    "imgs": ['https://i.imgur.com/vQPNguK.jpg'],
    "videos": [],
    "videoImg": "",
    "screens": []
  },
  "離不開你的依賴": {
    "name": "Dependence",
    "desc": "In a stylish romance, Sonoda, an aspiring writer turned editor, falls for Rina. Their relationship is tested by career struggles and unexpected talents. Polished cinematography and heartfelt moments make for a captivating watch.",
    "director": "Kento Yamaguchi",
    "actors": ['Moeka Hoshi,Hiroki Iijima,Mario Kuroba'],
    "imgs": ['https://i.imgur.com/i7UJP9s.jpg'],
    "videos": [],
    "videoImg": "",
    "screens": []
  },
  "窄路微塵": {
    "name": "Zhai lu wei chen",
    "desc": "Chak struggles to keep his cleaning company afloat under the pandemic as he meets Candy, who needs a job and Chu, her little daughter.",
    "director": "Lam Sum",
    "actors": ['Louis Cheung,Angela Yuen,Patra Au'],
    "imgs": ['https://i.imgur.com/hgA1pTB.jpg'],
    "videos": [],
    "videoImg": "",
    "screens": []
  },
  "閃電俠": {
    "name": "The Flash",
    "desc": "The Flash is a 2023 American superhero film based on the DC Comics character Barry Allen / Flash. Directed by Andy Muschietti from a screenplay by Christina Hodson and a story by Joby Harold and the writing team of John Francis Daley and Jonathan Goldstein, it is the 13th film in the DC Extended Universe (DCEU). Ezra Miller stars as Barry, who travels back in time to prevent his mother's death and becomes stranded in an alternate past. Sasha Calle also stars in her film debut, alongside Michael Shannon, Ron Livingston, Maribel Verdú, Kiersey Clemons, Antje Traue, and Michael Keaton. ",
    "director": "Andy Muschietti",
    "actors": ['Ezra Miller,Sasha Calle,Michael Shannon,Ron Livingston,Maribel Verdú'],
    "imgs": ['https://i.imgur.com/pNUSaIL.jpg'],
    "videos": [],
    "videoImg": "",
    "screens": []
  },
  "玩命關頭X": {
    "name": "Fast X",
    "desc": "Fast X (also known as Fast & Furious 10) is a 2023 American action film directed by Louis Leterrier from a screenplay written by Dan Mazeau and Justin Lin, both of whom also co-wrote the story with Zach Dean. It is the sequel to F9 (2021), the tenth main installment, and the eleventh installment overall in the Fast & Furious franchise. It stars Vin Diesel as Dominic Toretto alongside an ensemble cast including Michelle Rodriguez, Tyrese Gibson, Chris Ludacris Bridges, John Cena, Nathalie Emmanuel, Jordana Brewster, Sung Kang, Scott Eastwood, Daniela Melchior, Alan Ritchson, Helen Mirren, Brie Larson, Rita Moreno, Jason Statham, Jason Momoa, and Charlize Theron. In the film, Toretto must protect his family from Dante Reyes (Momoa), who seeks revenge for his father's death and the loss of his family's fortunes.",
    "director": "	Louis Leterrier",
    "actors": ['Vin Diesel,Michelle Rodriguez,Tyrese Gibson,Chris "Ludacris" Bridges,John Cena,Brie Larson,Jordana Brewster'],
    "imgs": ['https://i.imgur.com/h7aSlNl.jpg'],
    "videos": [],
    "videoImg": "",
    "screens": []
  }
}

const screenSizeMap_eng: { [key: string]: string } = {
  "豪華廳": "Luxury",
  "數位廳": "Digital",
}

const weekMap_eng: { [key: string]: string } = {
  "日": "Sun",
  "一": "Mon",
  "二": "Tue",
  "三": "Wed",
  "四": "Thu",
  "五": "Fri",
  "六": "Sat"
};

const monthMap: { [key: string]: { [key: string]: string } } = {
  "zh": {
    "01": "01月",
    "02": "02月",
    "03": "03月",
    "04": "04月",
    "05": "05月",
    "06": "06月",
    "07": "07月",
    "08": "08月",
    "09": "09月",
    "10": "10月",
    "11": "11月",
    "12": "12月",
  },
  "en": {
    "01": "Jan.",
    "02": "Feb.",
    "03": "Mar.",
    "04": "Apr.",
    "05": "May.",
    "06": "Jun.",
    "07": "Jul.",
    "08": "Aug.",
    "09": "Sep.",
    "10": "Oct.",
    "11": "Nov.",
    "12": "Dec.",
  }
};


const paymethodMap: { [key: string]: string } = {
  "信用卡": "Credit Card",
  "綠界科技-Credit_CreditCard": "ECPAY-Credit_CreditCard",
  "綠界科技-WebATM_TAISHIN": "ECPAY-WebATM_TAISHIN",
};

const levelMap: { [key: string]: { [key: number]: { level: string, color: string } } } = {
  'zh': {
    0: {
      level: '普',
      color: "#3ced9c"
    },
    1: {
      level: '護',
      color: "#2a72dd"
    },
    2: {
      level: '輔',
      color: "#ffc107"
    },
    3: {
      level: '限',
      color: "#f00"
    },
  },
  'en': {
    0: {
      level: 'G',
      color: "#3ced9c"
    },
    1: {
      level: 'PG',
      color: "#7e3b98"
    },
    2: {
      level: 'PG-13',
      color: "#ffc107"
    },
    3: {
      level: 'R',
      color: "#d8121a"
    },
  },
}

const levelZhToEng: { [key: string]: string } = {
  "普": "G",
  "護": "PG",
  "輔": "PG-13",
  "限": "R",
  "G": "G",
  "PG": "PG",
  "PG-13": "PG-13",
  "R": "R",
}


const paymentMethodMap_eng: { [key: string]: { [key: string]: {} } } = {
  "zh": {
    "creditCard": "信用卡",
    "ecPay": "綠界金流",
  },
  "en": {
    "creditCard": "Credit Card",
    "ecPay": "EC Pay",
  }
}

export const getEngErrMessage = (msg: string) => {
  const ErrMsgLabels = {
    "此帳號不存在": "Account does not exist",
    "密碼錯誤": "Password is incorrect",
    "信箱格式錯誤": "Eamil format is invalid",
    "該信箱已被註冊": "This mail address hes been resgisterd"
  }[msg]
  return ErrMsgLabels || "發生錯誤"
}

export const transMovieTitleName = (lang: string, movie_name?: string, orderBack?: boolean) => {
  if (!movie_name) {
    return
  }

  if (lang === 'zh') {
    return movie_name
  } else if (lang === 'en') {
    /*由於傳進來的電影名稱字串有會有2種型式，
    一種是有一般名稱 - "(XX廳)鈴芽之旅"
    另一種是訂票完成後的 - "鈴芽之旅(XX廳)""
    所以這裡在做正規表達式時，會先判別使用哪種過濾型式
    */
    const regex = (orderBack) ? /^(.*)\s\((.*)\)$/ : /^\(([^)]+)\)\s*(.+)$/
    const match = movie_name.match(regex);
    // 如果傳進來的電影名稱的字串為"(XX廳)鈴芽之旅"這樣的格式，
    if (match && !orderBack) {
      const movieName = movieDataMap_eng[match[2]]['name']
      const screenSize = screenSizeMap_eng[match[1]]
      return `(${screenSize}) ${movieName}`
    }

    // 如果傳進來的電影名稱的字串為"鈴芽之旅(XX廳)"這樣的格式，
    else if (match && orderBack) {
      const movieName = movieDataMap_eng[match[1]]['name']
      const screenSize = screenSizeMap_eng[match[2]]
      return `${movieName} (${screenSize})`
    }
    else {
      // 若是電影名稱的字串"鈴芽之旅"這樣的名稱，則直接對應其中、英對照
      return movieDataMap_eng[movie_name]['name']
    }
  }
}

export const transMovieInfo = (lang: string, movie_name: string, movie_info_data: any) => {
  if (!movie_name) {
    return
  }

  if (lang === 'zh') {
    return movie_info_data
  } else if (lang === 'en') {
    const { videos, videoImg, screens } = movie_info_data
    return { ...movieDataMap_eng[movie_name], videos, videoImg, screens }
  }
}

export const transMovieDescription = (lang: string, movie_name?: string, movie_desc?: string) => {
  if (!movie_name) {
    return
  }

  if (lang === 'zh') {
    return movie_desc
  } else if (lang === 'en') {
    return movieDataMap_eng[movie_name]['desc']
  }
}

export const transMoviePosterImg = (lang: string, movie_name: string, moviePosterImg: []) => {
  if (!movie_name) {
    return
  }

  if (lang === 'zh') {
    return moviePosterImg
  } else if (lang === 'en') {
    return movieDataMap_eng[movie_name]['imgs']
  }
}

export const transTheaterSize = (lang: string, data?: string) => {
  if (!data) {
    return
  }
  if (lang === 'zh') {
    return data
  } else if (lang === 'en') {
    return screenSizeMap_eng[data]
  }
}

export const transDateString = (lang: string, date: string) => {
  if (lang === 'zh') {
    return date
  } else if (lang === 'en') {
    const regex = /(\d{4}\/\d{2}\/\d{2}) \((.)\)/;
    const match = regex.exec(date);

    /*如果傳進來的時間字串為"2023/05/20 (六)"這樣的格式，則先用正則表達式將其拆開*/
    if (match) {
      const date = match[1];
      const chineseWeek = match[2];
      const englishWeek = weekMap_eng[chineseWeek] || chineseWeek;
      return `${date} (${englishWeek})`;
    }
    return date;
  }
}
export const transLevel = (lang: string, levelData: string) => {
  if (!lang || lang === 'zh') {
    return levelData
  }
  return levelZhToEng[levelData];
};

export const transLevelData = (lang: string = 'en', level: number = 0) => {
  return levelMap[lang || 'en'][level];
};


export const transPaymentMethod = (lang: string, payment: string) => {
  if (!payment) {
    return
  }
  return paymentMethodMap_eng[lang][payment]
}

// 轉換座位
export const transSeats = (lang: string, seats: string) => {
  if (!seats) {
    return
  }
  if (lang === 'zh') {
    return seats
  } else {
    /*將座位型式[A排4號] [A排5號] 轉為 "[A4] [A5]"*/
    const regex = /\[([A-Z])排(\d+)號\]/g;
    return seats.replace(regex, '[$1$2]');
  }
}

export const transArraySeats = (lang: string, seats: string[] = []) => {
  if (!seats || seats.length === 0) {
    return [];
  }
  if (lang === 'zh') {
    return seats.map(seat => `[${seat}]`).join(' ')
  } else {
    const regex = /^([A-Z])排(\d+)號$/;
    const newSeats = seats.map(seat => {
      return seat.replace(regex, '[$1$2]');
    });
    return newSeats.join(' ')
  }
}

export const transMonth = (lang: string, month: string): string => {
  return monthMap[lang || 'en'][month];
}

export const paymethod = (lang: string, pay_data: string) => {
  if (lang === 'zh') {
    return pay_data
  } else {
    return paymethodMap[pay_data]
  }
}  